import { CardActionsProps as MuiCardFooterProps } from '@mui/material/CardActions'

export type CardFooterProps = MuiCardFooterProps
